import React from "react";
import { createRoot } from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "theming";
import { themeA } from "assets/theme";
import { Provider } from "react-redux";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { store } from "./store";
import "react-toastify/dist/ReactToastify.css";

// import "./mocks/mockInterceptor"; // intercept axios
/**
 * Adapter for chart js
 */
import "chartjs-adapter-date-fns";

const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={themeA}>
        <App />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
